import { defineStore } from 'pinia';
import configuration from '../service/configuration';

const useConfiguration = defineStore('configuration', {
  // arrow function recommended for full type inference
  state: () => {
    return {
      configuration: {},
    };
  },
  actions: {
    async setGasoil({ gasoilId }) {
      try {
        const res = await configuration.setGasoil({ gasoilId });
        this.configuration = { selectedGasoil: res.config.selectedGasoil };
      } catch (error) {
        console.log(error);
      }
    },
    async getConfiguration() {
      try {
        const res = await configuration.getConfiguration();

        this.configuration = { selectedGasoil: res.result.selectedGasoil };
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export default useConfiguration;
